module.exports = __webpack_public_path__ + "static/media/choose_class_8_decoration.54dcc9d4.svg";